import React, { useEffect, useState } from "react";
import {
  CAvatar,
  CButton,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CSpinner,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import WidgetsD from "./WidgetsD";
import Mapbox from "./Mapbox";
import { getDashboardData } from "src/services/dashboard.services";
import { getSearchedBookingOrderList } from "src/services/booking.services";
import CIcon from "@coreui/icons-react";
import { cilPeople } from "@coreui/icons";
import { getAllUserTypeBySearch } from "src/services/user-type.services";
import moment from "moment";
import CustomPagination from "src/components/CustomPagination";
import { useNavigate } from "react-router";
import demoAvatar from "../../assets/images/avatars/avatar.png";
import { useQuery } from "@tanstack/react-query";
import { getDriverGpsLocation } from "src/services/gps-location.services";
const Dashboard = () => {
  //access User Data
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({});
  const [mapData, setMapData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [orderData, setOrderData] = useState([]);
  const [storeUserData, setStoreUserData] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const navigate = useNavigate();

  const {
    data: GPSLocationQueryData,
    isLoading: isLoadingGpsLocationQuery,
    status,
  } = useQuery({
    queryKey: ["gps-location-data"],
    queryFn: () => getDriverGpsLocation(null),
    enabled: ["superAdmin", "admin", "cvit"].includes(user.userType),
  });

  const getDashboardItem = () => {
    setIsLoading(true);
    getDashboardData()
      .then(async (response) => {
        const allData = response.data;
        setIsLoading(false);
        setData(allData);
        // const driverData = allData?.driverLocations;
        // if (driverData && driverData.length > 0) {
        //   let map = [];
        //   driverData.forEach((element) => {
        //     if (element.lastLocation) {
        //       const latTest =
        //         isFinite(element.lastLocation?.latitude) &&
        //         Math.abs(element.lastLocation?.latitude) <= 90;
        //       const longTest =
        //         isFinite(element.lastLocation?.longitude) &&
        //         Math.abs(element.lastLocation?.longitude) <= 180;
        //       if (latTest && longTest) {
        //         let obj = element.lastLocation;
        //         obj.name =
        //           element?.user?.firstName + " " + element?.user?.lastName;
        //         obj.avatar = element?.user?.avatar;
        //         obj.updatedAt = element.updatedAt;
        //         map.push(obj);
        //       }
        //     }
        //   });
        //   setMapData(map);
        // }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("dashboard axios error", error);
      });
  };

  const getBookingOrderItem = (page) => {
    setIsLoading(true);
    const param = {
      page,
      type: "manage",
    };
    getSearchedBookingOrderList(param)
      .then(async (response) => {
        const allData = response.data;
        setIsLoading(false);
        setOrderData(allData);
        const totalPages = Math.ceil(response.count / 10);
        setTotalPages(totalPages);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("dashboard axios error", error);
      });
  };
  const getUserType = () => {
    getAllUserTypeBySearch({ limit: 100, page: 1, type: "store" })
      .then(async (response) => {
        const userTypeInfo = response.data;
        if (userTypeInfo?.length > 0) {
          setStoreUserData(userTypeInfo[0]);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    getBookingOrderItem(newPage);
  };

  const handleRowClick = () => {
    navigate("/manage-booking-orders");
  };

  useEffect(() => {
    if ((!isLoading && GPSLocationQueryData, status === "success")) {
      const data = GPSLocationQueryData.data.locationData;

      if (Array.isArray(data) && data.length > 0) {
        setMapData(data);
      } else {
        setMapData([]);
      }
    }
  }, [GPSLocationQueryData, isLoadingGpsLocationQuery, status]);

  useEffect(() => {
    getDashboardItem();
    if (user?.userType) {
      if (!["superAdmin", "admin", "cvit"].includes(user.userType)) {
        getBookingOrderItem(currentPage);
        getUserType();
      }
    }
  }, []);
  return (
    <>
      <WidgetsD data={data} />
      {["superAdmin", "admin", "cvit"].includes(user.userType) ? (
        <CCard className="my-3">
          <CCardBody>
            <CRow>
              {isLoadingGpsLocationQuery ? (
                <CCol className="text-center mt-3">
                  <CSpinner color="primary" />
                  <p className="mt-3">
                    <em>
                      Collecting Driver Real-time Location Data... This might
                      take a while...
                    </em>
                  </p>
                </CCol>
              ) : (
                <Mapbox data={mapData} />
              )}
              {/* <img src={map} /> */}
            </CRow>
          </CCardBody>
        </CCard>
      ) : (
        <CCard className="my-3">
          <CCardBody>
            <CRow>
              <h5>Recent Orders</h5>
            </CRow>
            <CRow>
              <CTable align="middle" className="mb-0 border" hover responsive>
                <CTableHead color="light">
                  <CTableRow>
                    <CTableHeaderCell className="text-center">
                      Status
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      <CIcon icon={cilPeople} />
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      Booking Order ID
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      Transfer Order No.
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      Seal/Bag No.
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      From Location
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      To Location
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      From Location Code
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      To Location Code
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      Route Name
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      Priority
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      Pick Up Date
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      Pick Up Date
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      Remarks
                    </CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {isLoading ? (
                    <CTableRow className="text-center">
                      <CTableDataCell colSpan="16">Loading...</CTableDataCell>
                    </CTableRow>
                  ) : orderData.length == 0 ? (
                    <CTableRow className="text-center">
                      <CTableDataCell colSpan="13">
                        No data available
                      </CTableDataCell>
                    </CTableRow>
                  ) : (
                    orderData.map((item, index) => (
                      <CTableRow
                        v-for="item in tableItems"
                        key={index}
                        data-id={item._id}
                        data-status={item.status}
                        className={
                          item.priority == "emergency" ? "emergency-color" : ""
                        }
                        onClick={handleRowClick}
                      >
                        <CTableDataCell className="text-center">
                          {item.status == "New" ? (
                            <CButton
                              color="secondary"
                              className="text-capitalize"
                              size="sm"
                              style={{ color: "white" }}
                            >
                              {item.status}
                            </CButton>
                          ) : (
                            ""
                          )}
                          {item.status == "rejected" ? (
                            <CButton
                              color="danger"
                              className="text-capitalize"
                              size="sm"
                              style={{ color: "white" }}
                            >
                              {item.status}
                            </CButton>
                          ) : (
                            ""
                          )}
                          {item.status == "driver" ? (
                            <CButton
                              color="purple"
                              className="text-capitalize"
                              size="sm"
                            >
                              {item.status}
                            </CButton>
                          ) : (
                            ""
                          )}
                          {item.status == "delivered" ? (
                            <CButton
                              color="success"
                              className="text-capitalize"
                              size="sm"
                              style={{ color: "white" }}
                            >
                              {item.status}
                            </CButton>
                          ) : (
                            ""
                          )}
                          {item.status === "cvit" &&
                            (item.createdBy?.userType === storeUserData?._id ? (
                              <CButton
                                color="pink"
                                size="sm"
                                className="text-capitalize"
                              >
                                New
                              </CButton>
                            ) : (
                              <CButton
                                color="pink"
                                size="sm"
                                className="text-capitalize"
                              >
                                CDT
                              </CButton>
                            ))}

                          {item.status == "assigned" ? (
                            <CButton
                              color="gray"
                              className="text-capitalize"
                              size="sm"
                            >
                              {item.status}
                            </CButton>
                          ) : (
                            ""
                          )}
                        </CTableDataCell>
                        <CTableDataCell className="text-center">
                          {item.status == "cvit" ? (
                            <CAvatar
                              size="md"
                              src={
                                item?.orderAcceptRejectBy?.avatar
                                  ? item.orderAcceptRejectBy.avatar
                                  : demoAvatar
                              }
                              status="success"
                            />
                          ) : (
                            ""
                          )}
                          {item.status == "rejected" ? (
                            <CAvatar
                              size="md"
                              src={
                                item?.orderAcceptRejectBy?.avatar
                                  ? item.orderAcceptRejectBy.avatar
                                  : demoAvatar
                              }
                              status="success"
                            />
                          ) : (
                            ""
                          )}
                          {item.status == "assigned" ? (
                            <CAvatar
                              size="md"
                              src={
                                item?.tripAssignedBy?.avatar
                                  ? item.tripAssignedBy.avatar
                                  : demoAvatar
                              }
                              status="success"
                            />
                          ) : (
                            ""
                          )}
                          {item.status == "driver" ? (
                            <CAvatar
                              size="md"
                              src={
                                item?.tripAssignedTo?.avatar
                                  ? item.tripAssignedTo.avatar
                                  : demoAvatar
                              }
                              status="success"
                            />
                          ) : (
                            ""
                          )}
                          {item.status == "delivered" ? (
                            <CAvatar
                              size="md"
                              src={
                                item?.tripAssignedTo?.avatar
                                  ? item.tripAssignedTo.avatar
                                  : demoAvatar
                              }
                              status="success"
                            />
                          ) : (
                            ""
                          )}
                        </CTableDataCell>
                        <CTableDataCell className="text-center">
                          <div>{item.bookingOrderId}</div>
                        </CTableDataCell>
                        <CTableDataCell className="text-center">
                          <div>{item.transferOrderNo}</div>
                        </CTableDataCell>
                        <CTableDataCell className="text-center">
                          <div>{item.sealBag?.serialNo}</div>
                        </CTableDataCell>
                        <CTableDataCell className="text-center text-capitalize">
                          <div>{item?.fromLocation?.name}</div>
                        </CTableDataCell>
                        <CTableDataCell className="text-center text-capitalize">
                          <div>{item?.toLocation?.name}</div>
                        </CTableDataCell>
                        <CTableDataCell className="text-capitalize">
                          {item?.fromLocation?.locationCode}
                        </CTableDataCell>
                        <CTableDataCell className="text-capitalize">
                          {item?.toLocation?.locationCode}
                        </CTableDataCell>
                        <CTableDataCell className="text-capitalize">
                          {item?.tripRoute?.name}
                        </CTableDataCell>
                        <CTableDataCell className="text-capitalize">
                          {item.priority}
                        </CTableDataCell>
                        <CTableDataCell className="text-capitalize">
                          {moment(item.pickupDate).format("DD/MM/YYYY")}
                        </CTableDataCell>
                        <CTableDataCell className="text-capitalize">
                          {item.pickupTime}
                        </CTableDataCell>
                        <CTableDataCell className="text-capitalize">
                          {item?.remarks}
                        </CTableDataCell>
                      </CTableRow>
                    ))
                  )}
                </CTableBody>
              </CTable>
              <div className="mt-3">
                <CustomPagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            </CRow>
          </CCardBody>
        </CCard>
      )}
    </>
  );
};

export default Dashboard;
